import React from "react";

const CIALabsBadge = () => {
  return (
    <div className="fixed bottom-4 right-4 z-[9999]">
      <div className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-full shadow-lg hover:shadow-xl transition-shadow">
        <img 
          src="https://customer-assets.emergentagent.com/job_cia-operacional/artifacts/3tb1ht5b_Logo%20CIA%20PNG.png"
          alt="CIA Labs"
          className="h-6 w-6 rounded object-contain bg-white"
        />
        <span className="text-sm font-medium">Made by CIA Labs®</span>
      </div>
    </div>
  );
};

export default CIALabsBadge;
